// extracted by mini-css-extract-plugin
export var closeButton = "navigation-module--close-button--ykYsr";
export var languageLink = "navigation-module--language-link--NbtBK";
export var languageSelect = "navigation-module--language-select--frUKe";
export var nav = "navigation-module--nav--HdqH8";
export var navItem = "navigation-module--nav-item--viIGB";
export var onlyMobile = "navigation-module--only-mobile--nwWvn";
export var open = "navigation-module--open--fCqQ2";
export var ourOffer = "navigation-module--our-offer--vyiHS";